// TODO: fix this on backend
export function fixLineCrossingDirection(v: string) {
  return v === '' ? 'none' : v;
}
